const state = {
  photo1: '',
  photo2: '',
  photo3: '',
  photo4: '',
  photo5: '',
  photo6: '',
  photo7: '',
  photo8: '',
  photo9: ''
}

const mutations = {
  SET_PHOTO1(state, photo) {
    state.photo1 = photo
  },
  SET_PHOTO2(state, photo) {
    state.photo2 = photo
  },
  SET_PHOTO3(state, photo) {
    state.photo3 = photo
  },
  SET_PHOTO4(state, photo) {
    state.photo4 = photo
  },
  SET_PHOTO5(state, photo) {
    state.photo5 = photo
  },
  SET_PHOTO6(state, photo) {
    state.photo6 = photo
  },
  SET_PHOTO7(state, photo) {
    state.photo7 = photo
  },
  SET_PHOTO8(state, photo) {
    state.photo8 = photo
  },
  SET_PHOTO9(state, photo) {
    state.photo9 = photo
  },
  SET_PHOTO1_2(state, { photo1, photo2 }) {
    state.photo1 = photo1
    state.photo2 = photo2
  },
  SET_PHOTO3_4(state, { photo3, photo4 }) {
    state.photo3 = photo3
    state.photo4 = photo4
  },

  // SET_PHOTO5(state, { photo5 }) {
  //   state.photo5 = photo5
  // },
  CLEAR(state) {
    state.photo1 = ''
    state.photo2 = ''
    state.photo3 = ''
    state.photo4 = ''
    state.photo5 = ''
    state.photo6 = ''
    state.photo7 = ''
    state.photo8 = ''
    state.photo9 = ''
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
